import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "class-report"
};
var _hoisted_2 = {
  class: "class-report-content"
};
var _hoisted_3 = {
  class: "class-report-charts"
};
var _hoisted_4 = {
  class: "details-list-title"
};
var _hoisted_5 = {
  key: 0,
  class: "details-list"
};
var _hoisted_6 = {
  key: 1,
  class: "record-list"
};
import Empty from './Components/Empty.vue';
import recordList from './Components/RecordList';
import detailsList from './Components/DetailsList';
import { ref, watch } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getAcceptReport } from '@/api/index-ping';
import ReportCharts from './ReportCharts.vue';
import { chartsOption } from './chartsOption.js';
export default {
  __name: 'Class',
  props: {
    periodId: {
      type: String,
      default: ''
    },
    columns: {
      // 周期列表
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var total = ref(0);
    var loading = ref(true);
    var chartsData = ref(null);
    var queryParams = ref({
      evaluateObjectName: '',
      // 用户名 可选参数
      recordResult: '',
      // 验收结果 可选参数 查询全部时可传空
      recordTimeStr: '',
      // 记录时间 本周：period；今日：today 可选参数
      periodId: '',
      // 周期id 可选参数
      secondNodeId: '',
      // 指标分类 可选参数 查询全部时可传空
      groupId: '',
      // 小组id 可选参数
      type: 'class',
      // 类型 必选参数
      current: '1',
      // 当前页码 必选参数
      size: '10' // 每页查询数 必选参数
    });
    //  输入总条数
    var inputTotal = function inputTotal(value) {
      total.value = value;
    };

    /**
     * 验收报告【达标验收】
     * @returns {Promise<void>}
     */
    var getReport = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(periodId) {
        var _yield$getAcceptRepor, data, _chartsData, source, i, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              loading.value = true;
              _context.n = 1;
              return getAcceptReport({
                periodId: periodId,
                type: 'class'
              });
            case 1:
              _yield$getAcceptRepor = _context.v;
              data = _yield$getAcceptRepor.data;
              _chartsData = data.data;
              source = [];
              for (i = 0; i < _chartsData.histogram.length; i++) {
                source.unshift({
                  product: _chartsData.histogram[i].secondNodeName,
                  该周期分数: _chartsData.histogram[i].currentPeriodScore,
                  全周期平均分数: _chartsData.histogram[i].historyPeriodScore
                });
              }
              chartsOption.dataset.source = source;
              chartsData.value = _chartsData;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 3:
              _context.p = 3;
              loading.value = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function getReport(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var toShow = ref(false);
    // 点击进入详情
    var detailJump = function detailJump(item) {
      toShow.value = !toShow.value;
      if (toShow.value) {
        queryParams.value.secondNodeId = item.secondNodeId || '';
      }
    };
    var toShowAll = function toShowAll() {
      toShow.value = !toShow.value;
    };
    watch(function () {
      return props.periodId;
    }, function (val) {
      queryParams.value.periodId = val;
      console.log(queryParams.value, '12');
      if (val) getReport(val);
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(ReportCharts, {
        loading: loading.value,
        type: "class",
        data: chartsData.value
      }, null, 8, ["loading", "data"])]), _createElementVNode("div", _hoisted_4, [!toShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_unref(detailsList), {
        queryParams: queryParams.value,
        periodId: __props.periodId,
        "is-person": false,
        onDetailJump: detailJump
      }, null, 8, ["queryParams", "periodId"])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(recordList), {
        columns: __props.columns,
        queryParams: queryParams.value,
        onTotalCount: inputTotal,
        onToShowAll: toShowAll
      }, null, 8, ["columns", "queryParams"])]))])])]);
    };
  }
};